define('app/views/top_banner_view',['app/setup'], function(takhfifan) {

  takhfifan.TopBannerView = takhfifan.BaseView.extend({

    events: {
      'click  .banner-close': 'close'
    },

    initialize: function(options) {
      this.cookie = options.cookie;
      this.render();
    },

    render: function() {
      if ($.cookie(this.cookie) != 'true') {
        this.$el.show();
      }
    },

    close: function(e) {
      e.preventDefault();
      this.$el.slideUp('slow');
      this.setCookie({ expires: 1, name: this.cookie });
      return false;
    }

  });
});

